module.exports = __webpack_public_path__ + "img/Picture-frame.86ccad52.png";